import { BackendDefaultErrorMessage } from '../Models/Message.model';

interface ConvertStringObjectToBooleanKeyValuesParams {
  [x: string]: string;
}
interface ConvertStringObjectToBooleanKeyValuesReturn {
  [x: string]: boolean;
}
interface EmptyErrorReturn {
  [x: string]: BackendDefaultErrorMessage;
}
export const convertStringObjectToBooleanKeyValues = (
  actions: ConvertStringObjectToBooleanKeyValuesParams,
): ConvertStringObjectToBooleanKeyValuesReturn =>
  Object.keys(actions).reduce((acc: any, item: string) => ({ ...acc, [item]: false }), {});

export const convertStringObjectToEmptyErrorKeyValues = (
  actions: ConvertStringObjectToBooleanKeyValuesParams,
): EmptyErrorReturn =>
  Object.keys(actions).reduce((acc: any, item: string) => ({ ...acc, [item]: null }), {});
